import { render, staticRenderFns } from "./PrescriptionReview.vue?vue&type=template&id=34aa6f6c&scoped=true"
import script from "./PrescriptionReview.vue?vue&type=script&lang=js"
export * from "./PrescriptionReview.vue?vue&type=script&lang=js"
import style0 from "./PrescriptionReview.vue?vue&type=style&index=0&id=34aa6f6c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34aa6f6c",
  null
  
)

export default component.exports